export default __webpack_public_path__ + "static/media/logo3.6f1264e7.png";